import * as React from 'react'
import MediaQuery from 'react-responsive'
import { theme } from '$utils/theme'
import { HeaderLogo } from './components/HeaderLogo'
import { HeaderDropdownMenu } from './components/HeaderDropdownMenu'
import { HeaderWrapper, HeaderDiv, ProPremiumIcon } from './FirstLevelHeader.style'
import { userGroupService } from '$utils/services/userGroupService'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { localUserIdData } from '$utils/services/saveUserIdDataService/saveUserIdDataService'
import { Block } from '$views/components'

const proIcon = require('$icons/pro.svg')

const redirectToProPlan = () => history.push(routeProvider.caretakerPro)

const showProIcon = () => userGroupService.isCaretaker() && !localUserIdData.getUserIdData().hasActiveProSubscription

export const DesktopHeader: React.SFC = () => (
  <HeaderWrapper>
    <HeaderDiv marginBottom="base">
      <HeaderLogo />
      <Block flex>
        {showProIcon() && (
          <ProPremiumIcon content={proIcon} onClick={redirectToProPlan} clickable resize={{ height: 25, width: 80 }} />
        )}
        {!userGroupService.isGuest() && <HeaderDropdownMenu />}
      </Block>
    </HeaderDiv>
  </HeaderWrapper>
)

export const MobileHeader: React.SFC<Props> = () => (
  <HeaderDiv>
    <HeaderLogo />
    {showProIcon() && (
      <ProPremiumIcon content={proIcon} onClick={redirectToProPlan} clickable resize={{ height: 25, width: 60 }} />
    )}
  </HeaderDiv>
)

export const FirstLevelHeader: React.SFC<Props> = () => (
  <>
    <MediaQuery minWidth={theme.breakpoints.desktop}>
      <DesktopHeader />
    </MediaQuery>
    <MediaQuery maxWidth={theme.breakpoints.desktop - 1}>
      <MobileHeader />
    </MediaQuery>
  </>
)



// WEBPACK FOOTER //
// ./src/views/components/Layout/FirstLevelHeader/FirstLevelHeader.tsx